import { getReasonPhrase } from 'http-status-codes'
import { z } from 'zod'
import { parseDataOfType } from '../common/parseDataType'
import * as SentryClient from '../sentryClient'

export const apiErrorSchema = z.object({
  error: z.object({
    kind: z.string(),
    message: z.string()
  })
})
export type ApiError = z.infer<typeof apiErrorSchema>

export async function apiErrorHandler(res: Response): Promise<void> {
  if (!res.ok) {
    let apiError: ApiError
    let jsonData: unknown
    try {
      jsonData = await res.json()
      apiError = parseDataOfType(jsonData, apiErrorSchema)
    } catch {
      // instances when the backend does not return a json object
      const fallbackMessage = typeof jsonData === 'string' ? jsonData : getReasonPhrase(res.status)
      const fallbackError = new Error(fallbackMessage)
      SentryClient.captureException(fallbackError, {
        tags: { status_code: res.status },
        extra: {
          status: res.status,
          statusText: res.statusText,
          url: res.url
        }
      })
      throw fallbackError
    }
    const newApiError = new Error(apiError.error.message)
    SentryClient.captureException(newApiError, {
      tags: { status_code: res.status },
      extra: {
        status: res.status,
        statusText: res.statusText,
        url: res.url
      }
    })
    throw newApiError
  }
}
